<app-form-group [formGroup]="localGroup">
    <label [id]="id" class="text-standard">{{label}}</label>
    <select [id]="id" #select [ngClass]="classes" formControlName="control" (change)="onChange($event)">
        <ng-content></ng-content>
    </select>
    <span *ngIf="error" class="text-error text-small">{{error}}</span>
</app-form-group>